import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, Route } from 'react-router';
import {
  AddIdentityProviderPage,
  DomainVerificationPage,
  EditIdentityProviderPage,
  GoogleIdPCallbackPage,
  SSOSettingsPage,
} from '#route-bundles/authenticated.tsx';
import { NotFound } from '#screens/404/NotFound.tsx';
import { fallbackRenderNotFound } from '#screens/errors/fallbackRenderNotFound.tsx';
import { LoadingSpinner } from '#screens/loading/LoadingSpinner.tsx';
import { fromArray, Titled } from '#util/title.ts';

/**
 * {@link ssoRootRoute} contains all of the routing config for the /settings/sso path
 */
export const ssoRootRoute = (
  <Route
    element={
      <Suspense fallback={<LoadingSpinner />}>
        <Outlet />
      </Suspense>
    }
  >
    <Route
      path="add"
      element={
        <Titled title={(title) => fromArray(['Add SSO', title])}>
          <AddIdentityProviderPage />
        </Titled>
      }
    />
    <Route
      path="domains/:domainId/verify"
      element={
        <Titled title={(title) => fromArray(['Verify domain', title])}>
          <DomainVerificationPage />
        </Titled>
      }
    />
    <Route
      path="google-idp/callback"
      element={
        <Titled title={(title) => fromArray(['Google Workspace', title])}>
          <GoogleIdPCallbackPage />
        </Titled>
      }
    />
    <Route
      path=":providerId"
      element={
        <Titled title={(title) => fromArray(['Edit endpoint SSO', title])}>
          <ErrorBoundary fallbackRender={fallbackRenderNotFound}>
            <EditIdentityProviderPage />
          </ErrorBoundary>
        </Titled>
      }
    />
    <Route
      index={true}
      element={
        <Titled title={(title) => fromArray(['SSO', title])}>
          <SSOSettingsPage />
        </Titled>
      }
    />
    <Route index={true} path="*" element={<NotFound />} />
  </Route>
);
